import { render, staticRenderFns } from "./DrawCateEdit.vue?vue&type=template&id=423fea59&scoped=true"
import script from "./DrawCateEdit.vue?vue&type=script&lang=js"
export * from "./DrawCateEdit.vue?vue&type=script&lang=js"
import style0 from "./DrawCateEdit.vue?vue&type=style&index=0&id=423fea59&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423fea59",
  null
  
)

export default component.exports